import { Component, input, output } from '@angular/core';
import { InspectionEntryGroup } from '../inspection-entries.component';
import { InspectionEntryFormType } from '@pages/inspection-detail-page-v2/inspection-util';

@Component({
  standalone: false,
  selector: 'wr-inspection-entry-group-list[groups]',
  templateUrl: './inspection-entry-group-list.component.html',
  styleUrls: ['./inspection-entry-group-list.component.scss'],
})
export class InspectionEntryGroupListComponent {

  groups = input.required<InspectionEntryGroup[]>();

  loading = input.required<boolean>();

  selectedGroupId = input<string | undefined>();
  disabled = input(false);
  canEdit = input(false);

  selectedEntry = input<InspectionEntryFormType | undefined | null>();
  selectedEntry$ = output<InspectionEntryFormType>();
  selectedGroupIdChange = output<string | undefined>();
  deleteGroup = output<InspectionEntryGroup>();
  markPostProcessingDone = output<InspectionEntryFormType>();

  collapseChange(isCollapse: boolean, group: InspectionEntryGroup) {
    if (!isCollapse) {
      this.selectedGroupIdChange.emit(group.checkpointGroupId);
    }
  }

  deleteGroupClick(event: MouseEvent, group: InspectionEntryGroup): void {
    event.stopPropagation();
    this.deleteGroup.emit(group);
  }
}
